import React, { useEffect, useRef, useState } from "react";
import PageTitle from "../layouts/PageTitle";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import {
  postNotification,
  putNotification,
} from "../../services/PushNotification/NotificationService";
import ButtonLoader from "../components/Common/ButtonLoader/ButtonLoader";
import addPhoto from "../../services/Auth/AuthService";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Editor } from "@tinymce/tinymce-react";
import Select from "react-select/async";
import { getUserList } from "../../services/UserServices/UserService";

export default function Notification({
  updateNotification,
  setUpdateNotification,
  pushNotificationData,
}) {
  let errorsObj = {
    title: "",
    title_ch: "",
    title_zh: "",
    title_ms: "",
    title_id: "",
    title_vi: "",
    title_ko: "",
    title_ja: "",
    title_hi: "",
    message: "",
    message_ch: "",
    message_zh: "",
    message_ms: "",
    message_id: "",
    message_vi: "",
    message_ko: "",
    message_ja: "",
    message_hi: "",
    type: "",
    sendTo: "",
    websiteUrl: "",
    buttonText: "",
    buttonText_ch: "",
  };

  const formRef = useRef(null);
  const [errors, setErrors] = useState(errorsObj);
  const [formData, setFormData] = useState({
    title: "",
    title_ch: "",
    title_zh: "",
    title_ms: "",
    title_id: "",
    title_vi: "",
    title_ko: "",
    title_ja: "",
    title_hi: "",
    message: "",
    message_ch: "",
    message_zh: "",
    message_ms: "",
    message_id: "",
    message_vi: "",
    message_ko: "",
    message_ja: "",
    message_hi: "",
    type: "all",
    selectedUser: "",
    websiteUrl: "",
    buttonText: "",
    buttonText_ch: "",
    buttonText_zh: "",
    buttonText_ms: "",
    buttonText_id: "",
    buttonText_vi: "",
    buttonText_ko: "",
    buttonText_ja: "",
    buttonText_hi: "",
    image: "",
    sendTo: "",
    isPinned: false,
  });

  const [loader, setLoader] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState(null);

  console.log(selectedUsers, "selectedUsers");

  const handleChangeText = (content) => {
    setFormData({ ...formData, message: content });
    setErrors({ ...errors, message: "" });
  };
  const handleChangeTextCh = (content) => {
    setFormData({ ...formData, message_ch: content });
    setErrors({ ...errors, message_ch: "" });
  };
  const handleChangeTextZh = (content) => {
    setFormData({ ...formData, message_zh: content });
    setErrors({ ...errors, message_zh: "" });
  };
  const handleChangeTextMs = (content) => {
    setFormData({ ...formData, message_ms: content });
    setErrors({ ...errors, message_ms: "" });
  };
  const handleChangeTextId = (content) => {
    setFormData({ ...formData, message_id: content });
    setErrors({ ...errors, message_id: "" });
  };
  const handleChangeTextVi = (content) => {
    setFormData({ ...formData, message_vi: content });
    setErrors({ ...errors, message_vi: "" });
  };
  const handleChangeTextKo = (content) => {
    setFormData({ ...formData, message_ko: content });
    setErrors({ ...errors, message_ko: "" });
  };
  const handleChangeTextJa = (content) => {
    setFormData({ ...formData, message_ja: content });
    setErrors({ ...errors, message_ja: "" });
  };
  const handleChangeTextHi = (content) => {
    setFormData({ ...formData, message_hi: content });
    setErrors({ ...errors, message_hi: "" });
  };
  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  console.log(selectedUsers, "formData");
  //// function to post data ///
  const onSubmit = async (e) => {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (formData?.title.trim() === "") {
      errorObj.title = "Title is Required";
      error = true;
    }
    if (formData?.title_ch.trim() === "") {
      errorObj.title_ch = "Title is Required";
      error = true;
    }
    if (formData?.title_zh.trim() === "") {
      errorObj.title_zh = "Title is Required";
      error = true;
    }
    if (formData?.title_ms.trim() === "") {
      errorObj.title_ms = "Title is Required";
      error = true;
    }
    if (formData?.title_id.trim() === "") {
      errorObj.title_id = "Title is Required";
      error = true;
    }
    if (formData?.title_vi.trim() === "") {
      errorObj.title_vi = "Title is Required";
      error = true;
    }
    if (formData?.title_ko.trim() === "") {
      errorObj.title_ko = "Title is Required";
      error = true;
    }
    if (formData?.title_ja.trim() === "") {
      errorObj.title_ja = "Title is Required";
      error = true;
    }
    if (formData?.title_hi.trim() === "") {
      errorObj.title_hi = "Title is Required";
      error = true;
    }
    if (formData?.message.trim() === "") {
      errorObj.message = "Body is Required";
      error = true;
    }
    if (formData?.message_ch.trim() === "") {
      errorObj.message_ch = "Body is Required";
      error = true;
    }
    if (formData?.message_zh.trim() === "") {
      errorObj.message_zh = "Body is Required";
      error = true;
    }
    if (formData?.message_ms.trim() === "") {
      errorObj.message_ms = "Body is Required";
      error = true;
    }
    if (formData?.message_id.trim() === "") {
      errorObj.message_id = "Body is Required";
      error = true;
    }
    if (formData?.message_vi.trim() === "") {
      errorObj.message_vi = "Body is Required";
      error = true;
    }
    if (formData?.message_ko.trim() === "") {
      errorObj.message_ko = "Body is Required";
      error = true;
    }
    if (formData?.message_ja.trim() === "") {
      errorObj.message_ja = "Body is Required";
      error = true;
    }
    if (formData?.message_hi.trim() === "") {
      errorObj.message_hi = "Body is Required";
      error = true;
    }
    setErrors(errorObj);

    if (error) {
      return;
    }

    setLoader(true);

    console.log(formData, "formData");

    try {
      const dataToSend = {
        ...formData,
        selectedUser: selectedUsers !== null ? selectedUsers.value : "",
      };

      if (pushNotificationData) {
        const response = await putNotification({
          ...dataToSend,
          notificationId: pushNotificationData?._id,
        });
        notifyTopRight("Edit Successfully.");
      } else {
        const response = await postNotification(dataToSend);
        notifyTopRight("Sent Successfully.");
      }

      setUpdateNotification(true);

      handleChangeText("");
      handleChangeTextCh("");

      setFormData({
        title: "",
        title_ch: "",
        title_zh: "",
        title_ms: "",
        title_id: "",
        title_vi: "",
        title_ko: "",
        title_ja: "",
        title_hi: "",
        message: "",
        message_ch: "",
        message_zh: "",
        message_ms: "",
        message_id: "",
        message_vi: "",
        message_ko: "",
        message_ja: "",
        message_hi: "",
        type: "all",
        image: "",
        sendTo: "",
        websiteUrl: "",
        buttonText: "",
        buttonText_ch: "",
        buttonText_zh: "",
        buttonText_ms: "",
        buttonText_id: "",
        buttonText_vi: "",
        buttonText_ko: "",
        buttonText_ja: "",
        buttonText_hi: "",
        selectedUser: "",
        isPinned: false,
      });

      setSelectedUsers(null);

      // Reset the file input separately
      if (formRef.current) {
        formRef.current.querySelector('input[type="file"]').value = "";
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);
      notifyError("Something went wrong please try again!");
    }
  };
  const albumName = "notificationImage";

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "image") {
      const selectedFile = e.target.files[0];

      if (selectedFile) {
        addPhoto(selectedFile, albumName)
          .then((response) => {
            console.log(response, "image response");
            const imageName = response?.key;

            if (imageName) {
              setFormData({
                ...formData,
                image: imageName,
              });
            }
          })
          .catch((error) => {
            console.log(error, "image upload error");
          });
      }
    }
  };

  const loadUsers = async (inputValue) => {
    try {
      const response = await getUserList(
        0,
        20,
        inputValue,
        "",
        "",
        "all",
        "all",
        "all",
        "all",
        "createdAt",
        null,
        null
      );

      return response.data.data.users.map((user) => ({
        value: user._id,
        label: `${user.name} (${user.email || "No email"})`,
      }));
    } catch (error) {
      console.error("Error loading users:", error);
      return [];
    }
  };

  useEffect(() => {
    if (pushNotificationData) {
      setFormData({
        title: pushNotificationData?.title ? pushNotificationData?.title : "",
        title_ch: pushNotificationData?.title_ch
          ? pushNotificationData?.title_ch
          : "",
        title_zh: pushNotificationData?.title_zh
          ? pushNotificationData?.title_zh
          : "",
        title_ms: pushNotificationData?.title_ms
          ? pushNotificationData?.title_ms
          : "",
        title_id: pushNotificationData?.title_id
          ? pushNotificationData?.title_id
          : "",
        title_vi: pushNotificationData?.title_vi
          ? pushNotificationData?.title_vi
          : "",
        title_ko: pushNotificationData?.title_ko
          ? pushNotificationData?.title_ko
          : "",
        title_ja: pushNotificationData?.title_ja
          ? pushNotificationData?.title_ja
          : "",
        title_hi: pushNotificationData?.title_hi
          ? pushNotificationData?.title_hi
          : "",
        message: pushNotificationData?.message
          ? pushNotificationData?.message
          : "",
        message_ch: pushNotificationData?.message_ch
          ? pushNotificationData?.message_ch
          : "",
        message_zh: pushNotificationData?.message_zh
          ? pushNotificationData?.message_zh
          : "",
        message_ms: pushNotificationData?.message_ms
          ? pushNotificationData?.message_ms
          : "",
        message_id: pushNotificationData?.message_id
          ? pushNotificationData?.message_id
          : "",
        message_vi: pushNotificationData?.message_vi
          ? pushNotificationData?.message_vi
          : "",
        message_ko: pushNotificationData?.message_ko
          ? pushNotificationData?.message_ko
          : "",
        message_ja: pushNotificationData?.message_ja
          ? pushNotificationData?.message_ja
          : "",
        message_hi: pushNotificationData?.message_hi
          ? pushNotificationData?.message_hi
          : "",
        type: pushNotificationData?.sendedTo
          ? pushNotificationData?.sendedTo
          : "all",
        selectedUser: pushNotificationData?.senderId
          ? pushNotificationData?.senderId
          : "",
        websiteUrl: pushNotificationData?.websiteUrl
          ? pushNotificationData?.websiteUrl
          : "",
        buttonText: pushNotificationData?.buttonText
          ? pushNotificationData?.buttonText
          : "",
        buttonText_ch: pushNotificationData?.buttonText_ch
          ? pushNotificationData?.buttonText_ch
          : "",
        buttonText_zh: pushNotificationData?.buttonText_zh
          ? pushNotificationData?.buttonText_zh
          : "",
        buttonText_ms: pushNotificationData?.buttonText_ms
          ? pushNotificationData?.buttonText_ms
          : "",
        buttonText_id: pushNotificationData?.buttonText_id
          ? pushNotificationData?.buttonText_id
          : "",
        buttonText_vi: pushNotificationData?.buttonText_vi
          ? pushNotificationData?.buttonText_vi
          : "",
        buttonText_ko: pushNotificationData?.buttonText_ko
          ? pushNotificationData?.buttonText_ko
          : "",
        buttonText_ja: pushNotificationData?.buttonText_ja
          ? pushNotificationData?.buttonText_ja
          : "",
        buttonText_hi: pushNotificationData?.buttonText_hi
          ? pushNotificationData?.buttonText_hi
          : "",
        image: pushNotificationData?.photo ? pushNotificationData?.photo : "",
        sendTo: pushNotificationData?.subType
          ? pushNotificationData?.subType
          : "",
        isPinned: pushNotificationData?.isPinned
          ? pushNotificationData?.isPinned
          : false,
      });
      setSelectedUsers({
        label:
          pushNotificationData?.selectedUser?.name +
          `(${pushNotificationData?.selectedUser?.email})`,
        value: pushNotificationData?.selectedUser?._id,
      });
    } else {
      setFormData({
        title: "",
        title_ch: "",
        title_zh: "",
        title_ms: "",
        title_id: "",
        title_vi: "",
        title_ko: "",
        title_ja: "",
        title_hi: "",
        message: "",
        message_ch: "",
        message_zh: "",
        message_ms: "",
        message_id: "",
        message_vi: "",
        message_ko: "",
        message_ja: "",
        message_hi: "",
        type: "all",
        selectedUser: "",
        websiteUrl: "",
        buttonText: "",
        buttonText_ch: "",
        buttonText_zh: "",
        buttonText_ms: "",
        buttonText_id: "",
        buttonText_vi: "",
        buttonText_ko: "",
        buttonText_ja: "",
        buttonText_hi: "",
        image: "",
        sendTo: "",
        isPinned: false,
      });
      setSelectedUsers(null);
    }
  }, [pushNotificationData]);

  console.log(pushNotificationData, "pushNotificationData");

  return (
    <div>
      <div className="">
        <div className="authincation-content text-black p-5">
          <div className="mb-4">
            <h3 className="mb-1 font-w600 text-black ">Add Details</h3>
          </div>

          <form onSubmit={onSubmit} ref={formRef}>
            <div className="form-group mb-3">
              <label className="text-black font-w500">Image</label>
              <div className="contact-name">
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  name="image"
                  onChange={(e) => handleInputChange(e)}
                />
                <span className="validation-text"></span>
                {errors.image && (
                  <div className="text-danger fs-12">{errors.image}</div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(English)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title"
                value={formData.title}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title && (
                <div className="text-danger fs-12">{errors.title}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(Chinese)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title_ch"
                value={formData.title_ch}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title_ch && (
                <div className="text-danger fs-12">{errors.title_ch}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(Chinese traditional)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title_zh"
                value={formData.title_zh}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title_zh && (
                <div className="text-danger fs-12">{errors.title_zh}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(Malay bahasa melayu)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title_ms"
                value={formData.title_ms}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title_ms && (
                <div className="text-danger fs-12">{errors.title_ms}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(Indonesian bahasa indonesia)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title_id"
                value={formData.title_id}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title_id && (
                <div className="text-danger fs-12">{errors.title_id}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(Vietnamese)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title_vi"
                value={formData.title_vi}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title_vi && (
                <div className="text-danger fs-12">{errors.title_vi}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(Korean)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title_ko"
                value={formData.title_ko}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title_ko && (
                <div className="text-danger fs-12">{errors.title_ko}</div>
              )}
            </div>

            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(Japanese)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title_ja"
                value={formData.title_ja}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title_ja && (
                <div className="text-danger fs-12">{errors.title_ja}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Title(Hindi)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="title_hi"
                value={formData.title_hi}
                onChange={handleInput}
                placeholder="Enter title"
              />
              {errors.title_hi && (
                <div className="text-danger fs-12">{errors.title_hi}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(English)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeText}
                name="prescription"
                value={formData.message}
              />
              {errors.message && (
                <div className="text-danger fs-12">{errors.message}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(Chinese)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeTextCh}
                name="prescription"
                value={formData.message_ch}
              />

              {errors.message_ch && (
                <div className="text-danger fs-12">{errors.message_ch}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(Chinese traditional)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeTextZh}
                name="prescription"
                value={formData.message_zh}
              />
              {errors.message_zh && (
                <div className="text-danger fs-12">{errors.message_zh}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(Malay bahasa melayu)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeTextMs}
                name="prescription"
                value={formData.message_ms}
              />
              {errors.message_ms && (
                <div className="text-danger fs-12">{errors.message_ms}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(Indonesian bahasa indonesia)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeTextId}
                name="prescription"
                value={formData.message_id}
              />
              {errors.message_id && (
                <div className="text-danger fs-12">{errors.message_id}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(Vietnamese)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeTextVi}
                name="prescription"
                value={formData.message_vi}
              />
              {errors.message_vi && (
                <div className="text-danger fs-12">{errors.message_vi}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(Korean)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeTextKo}
                name="prescription"
                value={formData.message_ko}
              />
              {errors.message_ko && (
                <div className="text-danger fs-12">{errors.message_ko}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(Japanese)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeTextJa}
                name="prescription"
                value={formData.message_ja}
              />
              {errors.message_ja && (
                <div className="text-danger fs-12">{errors.message_ja}</div>
              )}
            </div>
            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Body(Hindi)</strong>
              </label>
              <Editor
                apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
                init={{
                  height: 300,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image code charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code textcolor wordcount",
                    "textarea",
                    "textcolor",
                    "forecolor backcolor",
                    "link",
                  ],
                  toolbar: [
                    "undo redo | formatselect | code | link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify",
                    "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                  ],
                  content_style: "body { color: #000 }",
                  link_default_target: "_blank",
                  link_assume_external_targets: true,
                  link_title: true,
                  link_context_toolbar: true,
                  link_rel_list: [
                    { title: "None", value: "" },
                    { title: "No follow", value: "nofollow" },
                    { title: "No referrer", value: "noreferrer" },
                  ],
                }}
                onEditorChange={handleChangeTextHi}
                name="prescription"
                value={formData.message_hi}
              />
              {errors.message_hi && (
                <div className="text-danger fs-12">{errors.message_hi}</div>
              )}
            </div>

            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Send To</strong>
              </label>
              <select
                className="form-control"
                name="type"
                value={formData.type}
                onChange={handleInput}
              >
                <option value={"all"}>All</option>
                <option value={"male"}>Males</option>
                <option value={"female"}>Females</option>
                <option value={"premium"}>Member</option>
                <option value={"nonPremium"}>Non Member</option>
              </select>

              {errors.type && (
                <div className="text-danger fs-12">{errors.type}</div>
              )}
            </div>

            <div className="form-group">
              <label className="mb-2 ">
                <strong className="">Type</strong>
              </label>
              <select
                className="form-control"
                name="sendTo"
                value={formData.sendTo}
                onChange={handleInput}
              >
                <option value={"okay"}>Default</option>
                <option value={"website"}>Website</option>
                <option value={"userProfile"}>User Profile</option>
                <option value={"becomeMember"}>Become Member</option>
                <option value={"personalisation"}>Personal lisation</option>
              </select>

              {errors.type && (
                <div className="text-danger fs-12">{errors.type}</div>
              )}
            </div>

            {formData.sendTo === "userProfile" && (
              <div className="form-group">
                <label className="mb-2">
                  <strong className="">Select Users</strong>
                </label>
                <Select
                  // isMulti
                  cacheOptions
                  defaultOptions
                  value={selectedUsers}
                  onChange={setSelectedUsers}
                  loadOptions={loadUsers}
                  placeholder="Search and select users..."
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
            )}

            {formData.sendTo === "website" && (
              <div className="form-group">
                <label className="mb-2">
                  <strong className="">Website Url</strong>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="websiteUrl"
                  value={formData.websiteUrl}
                  onChange={handleInput}
                  placeholder="Enter website url"
                />
              </div>
            )}

            <div className="form-group">
              <label className="mb-2">
                <strong className="">Button Text(English)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText"
                value={formData.buttonText}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>

            <div className="form-group">
              <label className="mb-2">
                <strong className="">Button Text(Chinese)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText_ch"
                value={formData.buttonText_ch}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>
            <div className="form-group">
              <label className="mb-2">
                <strong className="">Button Text(Chinese traditional)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText_zh"
                value={formData.buttonText_zh}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>
            <div className="form-group">
              <label className="mb-2">
                <strong className="">Button Text(Malay bahasa melayu)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText_ms"
                value={formData.buttonText_ms}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>
            <div className="form-group">
              <label className="mb-2">
                <strong className="">
                  Button Text(Indonesian bahasa indonesia)
                </strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText_id"
                value={formData.buttonText_id}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>
            <div className="form-group">
              <label className="mb-2">
                <strong className="">Button Text(Vietnamese)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText_vi"
                value={formData.buttonText_vi}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>
            <div className="form-group">
              <label className="mb-2">
                <strong className="">Button Text(Korean)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText_ko"
                value={formData.buttonText_ko}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>
            <div className="form-group">
              <label className="mb-2">
                <strong className="">Button Text(Japanese)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText_ja"
                value={formData.buttonText_ja}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>
            <div className="form-group">
              <label className="mb-2">
                <strong className="">Button Text(Hindi)</strong>
              </label>
              <input
                type="text"
                className="form-control"
                name="buttonText_hi"
                value={formData.buttonText_hi}
                onChange={handleInput}
                placeholder="Enter button text"
              />
            </div>

            <div className="form-group">
              <div
                className="custom-control custom-checkbox d-flex align-items-center gap-2 p-2"
                style={{
                  background: "#f8f9fa",
                  borderRadius: "8px",
                  border: "1px solid #e9ecef",
                }}
              >
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="isPinned"
                  name="isPinned"
                  checked={formData.isPinned}
                  onChange={handleInput}
                  style={{
                    width: "18px",
                    height: "18px",
                    cursor: "pointer",
                  }}
                />
                <label
                  className="custom-control-label d-flex align-items-center gap-2 mb-0"
                  htmlFor="isPinned"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fas fa-thumbtack me-1"></i>
                  Pin this notification
                  {formData.isPinned && (
                    <span
                      className="badge bg-primary"
                      style={{ fontSize: "0.75rem" }}
                    >
                      Pinned
                    </span>
                  )}
                </label>
              </div>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={loader}
              >
                {loader ? (
                  <>
                    <ButtonLoader /> Send
                  </>
                ) : (
                  "Send"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
